module.exports = __webpack_public_path__ + "img/login-phone-screen.f809c580.png";